export const informationOptions: Record<string, readonly string[]> = {
  artCondition: ["Excellent", "Good", "Fair", "Poor"],
  support: ["Yupo", "140 Pound", "300 Pound", "Rice Paper", "Unconventional"],
  pressType: ["Hot Press", "Cold Press", "Rough Press"],
  texture: ["Ultra Smooth", "Medium Grain", "Rough Grain"],
  tint: ["Bright White", "Natural White", "Warm White", "Antique", "Cream"],
  materials: ["Water Color", "Oil Base", "Acrylic", "Graphite", "Chalk", "Charcoal", "Ink"],
  orientation: ["Landscape", "Portrait"],
  publish: ["true", "false"],
  sale: ["true", "false"],
  sold: ["true", "false"]
};

export function mediumValues(value: unknown): string[] {
  if (Array.isArray(value)) return value.filter((item): item is string => typeof item === "string");
  if (typeof value !== "string" || !value.trim()) return [];
  // Retain unfamiliar values as options instead of discarding old catalog information.
  try {
    const parsed: unknown = JSON.parse(value);
    if (Array.isArray(parsed)) return mediumValues(parsed);
  } catch {
    /* Legacy comma-separated values are also supported. */
  }
  return value
    .split(/[,;|]/u)
    .map((item) => item.trim())
    .filter(Boolean);
}
